jQuery(function($)
{
    /**
	 * @type {object jQuery}
	 */
    var $selectAllCheckboxes = $('.js-select-all');

    if (!$selectAllCheckboxes.length)
    {
        return;
    }

    /**
	 * Initialize select all checkbox
	 */
    function init()
    {
        console.log('select-all.js init');
        $selectAllCheckboxes = $('.js-select-all');
        initEvents();
    }

    /**
	 * Initialize events
	 */
    function initEvents()
    {
        $selectAllCheckboxes.off('click', handleClickSelectAll).on('click', handleClickSelectAll);

        $('[type=checkbox][data-checkbox-select-group]')
            .off('click', handleClickSingleCheckbox)
            .on('click', handleClickSingleCheckbox);
    }

    /**
	 * Fetch and return all checkboxes to select
	 */
    function fetchCheckboxesToSelect(selectGroup)
    {
        var $checkboxes = $('input[data-checkbox-select-group=' + selectGroup + ']').filter(function()
        {
            return !$(this).hasClass('js-select-all');
        });

        return $checkboxes;
    }

    /**
	 * Checks if all single checkboxes are checked
	 */
    function checkifAllChecked(selectGroup)
    {
        var $checkboxes = fetchCheckboxesToSelect(selectGroup);

        var allChecked = true;

        $checkboxes.each(function()
        {
            if ($(this)[0].checked == false)
            {
                allChecked = false;
            }
        });

        return allChecked;
    }

    /**
	 * Check or uncheck all checkboxes on click
	 */
    function handleClickSelectAll()
    {
        var selectGroup = $(this).data('checkboxSelectGroup');
        var $checkboxes = fetchCheckboxesToSelect(selectGroup);

        if ($(this)[0].checked)
        {
            $checkboxes.each(function()
            {
                if (!$(this).prop('checked'))
                {
                    $(this).click();
                }
            });
        }
        else
        {
            $checkboxes.each(function()
            {
                $(this).prop('checked', false);
            });
        }
    }

    /**
	 * Uncheck 'select all checkbox' if a single checkbox getting unchecked
	 */
    function handleClickSingleCheckbox()
    {
        var selectGroup = $(this).data('checkboxSelectGroup');

        var $selectAllCheckbox = $selectAllCheckboxes.filter(function()
        {
            return $(this).data('checkboxSelectGroup') == selectGroup;
        });

        if (!$(this)[0].checked)
        {
            $selectAllCheckbox.prop('checked', false);
        }

        if (checkifAllChecked(selectGroup) && !$selectAllCheckbox[0].checked)
        {
            $selectAllCheckbox.prop('checked', true);
        }
    }

    init();
    $('#content').on(orion.constants.EventProductListReloaded, function()
    {
        init();
    });
});
